import * as React from "react";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import Render from "source/app/presentation/Shared/Render";
import * as moment from "moment";

export function ShowLastRecordText({
    isLastRecord,
    date,
}: {
    isLastRecord: boolean;
    date: string;
}) {
    const currentTime = moment().format("HH:mm:ss");
    const passedTimeText = moment(`${date} ${currentTime}`).local().fromNow();

    return (
        <Render
            id="lastRecordText"
            when={isLastRecord}
            withClasses={StyleClass(`lastEmotionRecordValueText`, {
                color: "white",
                fontSize: "10px",
                position: "absolute",
                top: "24px",
                left: "-38px",
                opacity: 0.5,
                width: "100px",
            })}
        >
            ▲ <div>{passedTimeText}</div>
        </Render>
    );
}
